import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const TrophyIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Trophy",
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.84 6.67h-5.06V4.72c0-.64-.52-1.16-1.16-1.16H9.39c-.64 0-1.16.52-1.16 1.16v1.95H3.16C2.52 6.67 2 7.19 2 7.83v2.72c0 1.75 1.09 3.5 3.01 4.89 1.5 1.08 3.32 1.81 5.3 2.03h.05c.83 1.45 1.94 2.65 3.27 3.56l.04.02v3.5h-2.33c-1.75 0-3.11 1.01-3.11 2.72v.59c0 .32.27.58.59.58H23.2c.32 0 .58-.26.59-.58v-.59c0-1.75-1.4-2.72-3.11-2.72h-2.33v-3.5c1.36-.93 2.48-2.13 3.28-3.53l.03-.05c2.03-.22 3.85-.95 5.38-2.05l-.03.02c1.91-1.37 3.01-3.16 3.01-4.89V7.83c0-.65-.52-1.16-1.15-1.16ZM6.83 12.93c-.88-.5-1.53-1.35-1.75-2.35v-.8h3.15c.04 1.51.27 2.95.65 4.32l-.03-.12c-.77-.27-1.44-.62-2.04-1.06l.02.02Zm20.06-2.37c0 .78-.87 1.75-1.75 2.37-.58.42-1.26.77-1.97 1.02l-.06.02c.36-1.25.58-2.69.62-4.17v-.02h3.12z"
    })
  }));
};